import {autoinject, customElement, bindable} from "aurelia-framework";
import {Cart, CartService, GiftCard} from "../cart-service";
import {EventAggregator} from 'aurelia-event-aggregator';
import {UpdateShoppingCartMessage} from "../events/update-shopping-cart-message";
import {Router} from "aurelia-router";

@customElement('shopping-cart')
@autoinject()
export class ShoppingCart {

    @bindable
    public config: CartConfig;

    private giftCards: GiftCard[];

    private cart: Cart;

    constructor(private eventAggregator: EventAggregator, private cartService: CartService, private router: Router) {
    }


    attached() {
        this.cartService.getCart().then(cart => {
            this.giftCards = cart.giftCards;
            this.cart = cart;
        });

        this.eventAggregator.subscribe(UpdateShoppingCartMessage, mesage => {
            this.giftCards = this.cart.giftCards.slice(0);
        })
    }

    private shippingCostsString(): string {
        return `${this.cartService.getShippingCostString()} €`
    }

    private shippingCostsAmount(): number {
        return this.cartService.getShippingCostAmount()
    }

    private goToCart() {
        this.router.navigate("page3-cart")
    }

}

export class CartConfig {
    constructor(public show: boolean = false, public showCouponImage: boolean = true) {}
}
